var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M19.4,7.352,16.66,4.6A2,2,0,0,0,14,4.532L5,13.564a2.01,2.01,0,0,0-.57,1.214L4,18.964a1,1,0,0,0,1,1.094h.09l4.17-.381a2,2,0,0,0,1.21-.572l9-9.033a1.932,1.932,0,0,0-.07-2.72ZM9.08,17.669l-3,.281.27-3.011L12,9.339l2.7,2.71ZM16,10.7l-2.68-2.69,1.95-2.007L18,8.747Z",
    transform: "translate(-3.996 -4.058)",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c2a462700fd67100a5e96044ddd26ac4.svg";
export { ForwardRef as ReactComponent };